<template>
  <div class="bi-layout compair-layout">
    <h1 class="mb-8">Facebook Ads Vergleichen</h1>
    <vs-tabs v-model="currTab">
      <vs-tab label="Kampagnen"></vs-tab>
      <vs-tab label="Anzeigen"></vs-tab>
      <vs-tab label="Anzeigegruppen"></vs-tab>
    </vs-tabs>
    <div class="vx-row mt-6">
      <div class="vx-col w-full lg:w-1/2">
        <BiCompairBoxFacebook
          :max-y="maxY"
          :mode="fbAdMode"
          @max-y-updated="e => onMaxY('a', e)"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <BiCompairBoxFacebook
          :max-y="maxY"
          :mode="fbAdMode"
          @max-y-updated="e => onMaxY('b', e)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BiCompairBoxFacebook from "@/components/bi/BiCompairBoxFacebook.vue";

export default {
  components: {
    BiCompairBoxFacebook
  },
  data: () => ({
    maxValues: { a: 0, b: 0 },
    currTab: 0
  }),
  computed: {
    maxY() {
      return Math.max(this.maxValues["a"], this.maxValues["b"]);
    },
    fbAdMode() {
      return ["CAMPAIGNS", "ADS", "ADGROUPS"][this.currTab];
    }
  },
  methods: {
    onMaxY(chartIdx, value) {
      this.maxValues[chartIdx] = value;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
